<div class="overlay">
  <div class="modal-container">

    <span *ngIf="visivel === 'mais'" class="btn-back" (click)="visivel = 'info'"> <i class="fas fa-angle-left"></i> Anterior</span>

    <div class="modal-body" *ngIf="visivel === 'info'">
      <h2 class="modal-title text-center">Atenção:</h2>
      <p class="modal-description mt-3">
        Identificamos que você está utilizando um navegador não autorizado ou possui plugins ativos.
        Para continuar, utilize um navegador permitido (Edge, Google Chrome ou Safari) e desative quaisquer plugins ou extensões.
      </p>
      <h3 class="section-subtitle text-center">Verifique os pontos, abaixo:</h3>
      <ul class="points-list ml-5">
        <li>Se o navegador utilizado está autorizado para a utilização do portal;</li>
        <li>Se os plugins ou extensões do navegador estão desativados. <span class="modal-link" (click)="visivel = 'mais'">Saiba mais.</span></li>
      </ul>
      <h3 class="section-subtitle mt-3 text-center">Navegadores autorizados:</h3>
      <ul class="browsers-list ml-5">
        <li><a href="https://www.microsoft.com/pt-br/edge/download" target="_blank" rel="noopener noreferrer" class="modal-link">Edge</a></li>
        <li><a href="https://www.google.com/intl/pt-PT/chrome/" target="_blank" rel="noopener noreferrer" class="modal-link">Google Chrome</a></li>
        <li>Safari</li>
      </ul>
    </div>

    <div class="modal-body" *ngIf="visivel === 'mais'">
      <p class="section-subtitle mt-3">Para validar se você possui plugins ou extensões ativos,
        realize os procedimentos abaixo, de acordo com o navegador utilizado:
      </p>

      <div class="row justify-content-center w-100 text-left my-4">
        <div class="col-12 col-md-5 mb-4 mb-md-0">
          <h3 class="section-subs text-center">Edge ou Google Chrome</h3>
          <ul class="browsers-list pl-3">
            <li>Clique em "Configurações" (nos três pontinhos), no canto superior direito;</li>
            <li>Selecione "Extensões";</li>
            <li>Clique em Gerenciar Extensões;</li>
            <li>Serão exibidos todos os plugins e extensões do navegador.</li>
          </ul>
        </div>
        <div class="col-12 col-md-5">
          <h3 class="section-subs text-center">Safari</h3>
          <h3 class="section-subtitle">MAC</h3>
          <ul class="browsers-list ml-5">
            <li>Clique em "Safari", no canto superior esquerdo;</li>
            <li>Selecione "Configurações";</li>
            <li>Clique em "Extensões";</li>
            <li>Serão exibidos todos os plugins e extensões do navegador.</li>
          </ul>

          <h3 class="section-subtitle">iPad ou iPhone</h3>
          <ul class="browsers-list ml-5">
            <li>Selecione "Ajuste" no dispositivo;</li>
            <li>Clique em "Apps";</li>
            <li>Selecione o app "Safari";</li>
            <li>Clique em "Extensões";</li>
            <li>Serão exibidos todos os plugins e extensões do navegador.</li>
          </ul>
        </div>
      </div>





      <h3 class="section-subtitle">
        Para a utilização do Portal do Investidor é necessário que todos os
        plugins ou extensões do navegador estejam desativados.
      </h3>
    </div>

    <div class="button-container">
      <button class="btn-ok" (click)="close()">OK</button>
    </div>

  </div>

</div>
